import { EmptyTable } from "./EmptyTable";
import { NoImage } from "./NoImage";

export const Images = { EmptyTable, NoImage };
